import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader } from "lucide-react";

const StudentDashboard = () => {
  const [activeTab, setActiveTab] = useState("learning");
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCourses = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(
          `https://us-central1-extent-protocol-a.cloudfunctions.net/getMyCourses?token=${token}`
        );
        const data = Array.isArray(response.data)
          ? response.data
          : response.data.courses || [];
        setCourses(
          data.map((course) => ({
            id: course.id,
            title: course.name,
            description: course.description,
            category: course.category,
            image: course.cover_image,
            createdAt: course.created_at,
            publicId: course.publicId,
            status: "learning",
          }))
        );
      } catch (error) {
        console.error("Ошибка при загрузке курсов:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  const goToCourse = async (publicId) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `https://us-central1-extent-protocol-a.cloudfunctions.net/getCourse`,
        {
          params: {
            token,
            publicId,
          },
        }
      );
      console.log("Course data:", response.data);
      if (token && publicId) {
        navigate(`/course?publicId=${publicId}`);
      }
    } catch (error) {
      console.error("Ошибка при переходе к курсу:", error);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="flex flex-col items-center space-y-4">
          <Loader className="w-12 h-12 text-green-600 animate-spin" />
          <p className="text-gray-600">Загрузка курсов...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-3xl font-bold text-gray-800 mb-8">Мои курсы</h1>

      <div className="flex space-x-1 mb-8 bg-white rounded-lg p-1 shadow-sm border border-gray-200 w-fit">
        <button
          className={`px-6 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
            activeTab === "learning"
              ? "bg-green-600 text-white shadow-sm"
              : "text-gray-600 hover:text-green-600 hover:bg-green-50"
          }`}
          onClick={() => setActiveTab("learning")}
        >
          Моё обучение
        </button>
        {/* <button
          className={`px-6 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
            activeTab === "completed"
              ? "bg-green-600 text-white shadow-sm"
              : "text-gray-600 hover:text-green-600 hover:bg-green-50"
          }`}
          onClick={() => setActiveTab("completed")}
        >
          Завершенные
        </button> */}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {courses
          .filter((course) => course.status === activeTab)
          .map((course) => (
            <div
              key={course.id}
              className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden cursor-pointer transform transition-all duration-200 hover:shadow-lg hover:-translate-y-1 hover:border-green-200"
              onClick={() => goToCourse(course.publicId)}
            >
              <img
                src={course.image}
                alt={course.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h2 className="text-lg font-semibold text-gray-800 mb-2 line-clamp-2">
                  {course.title}
                </h2>
                <div
                  className="text-sm text-gray-600 line-clamp-3"
                  dangerouslySetInnerHTML={{ __html: course.description }}
                />
              </div>
            </div>
          ))}
      </div>

      {courses.filter((course) => course.status === activeTab).length === 0 && (
        <div className="text-center py-12">
          <div className="text-gray-400 text-6xl mb-4">📚</div>
          <h3 className="text-xl font-medium text-gray-600 mb-2">
            Курсы не найдены
          </h3>
          <p className="text-gray-500">
            У вас пока нет курсов в этой категории
          </p>
        </div>
      )}
    </div>
  );
};

export default StudentDashboard;